import React from "react";
import "../styles/LatestUpdates.css";
import oneDataShare from "../images/oneDataShare_img.jpg";

const LatestUpdates = () => {
  return (
    <div className="news-box">
      {/* Image on Top (Like News) */}
      <div className="news-image-wrapper">
        <img src={oneDataShare} alt="OneDataShare" className="news-image" />
      </div>

      {/* Text Below */}
      <div className="news-content">
        <h3>Latest Updates</h3>
        <p>
          "Working on integration of MinIo as a cloud storage for{" "}
          <a href="https://onedatashare.org" target="_blank" rel="noopener noreferrer" className="ods-link">
            onedatashare.org
          </a>
          ."
        </p>

        <p className="bold-text">Research Software Engineer at University at Buffalo</p>

        <p>Under Dr. Tevfik Kosar</p>
      </div>
    </div>
  );
};

export default LatestUpdates;
